import goCardlessImage from './goCardlessCover.png'
import {
  GreyGrey90,
  Image,
  Primary13Regular,
  Box,
  Flex
} from '@sequencehq/core-components'

export const GoCardlessIntegrationDetail = () => {
  return (
    <Flex flexDirection="column" gap="20px">
      <Image
        src={goCardlessImage}
        width="100%"
        borderRadius="8px"
        draggable={false}
      />
      <Box {...Primary13Regular} color={GreyGrey90} lineHeight="18px">
        Set up direct debits, collect payments from customers and reconcile
        Sequence invoices automatically.
      </Box>
    </Flex>
  )
}
